module.exports = __webpack_public_path__ + "static/media/plane.52715f7a.svg";